(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-cart-discount"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-ct-cart-discount]');
    if (!root) return;

    var input = root.querySelector('[data-ct-discount-input]');
    var button = root.querySelector('[data-ct-discount-apply]');
    var message = root.querySelector('[data-ct-discount-message]');
    var list = root.querySelector('[data-ct-discount-codes]');
    var busy = false;

    function setMessage(text, isError) {
      message.textContent = text || '';
      message.classList.toggle('ct-cart-discount__message--error', !!isError);
    }

    function getCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    function updateCodes(codes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      });
    }

    function appliedCodes(cart) {
      return (cart.discount_codes || [])
        .filter(function (d) { return d.applicable; })
        .map(function (d) { return d.code; });
    }

    function renderCodes(cart) {
      list.innerHTML = '';
      appliedCodes(cart).forEach(function (code) {
        var li = document.createElement('li');
        li.className = 'ct-cart-discount__code';
        li.textContent = code;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'ct-cart-discount__remove';
        remove.setAttribute('aria-label', 'Code ' + code + ' entfernen');
        remove.textContent = '×';
        remove.addEventListener('click', function () { removeCode(code); });
        li.appendChild(remove);
        list.appendChild(li);
      });
    }

    function rebuildDrawer() {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }

    function run(task) {
      if (busy) return;
      busy = true;
      button.setAttribute('aria-busy', 'true');
      task().catch(function () {
        setMessage('Das hat nicht geklappt. Bitte versuch es noch einmal.', true);
      }).then(function () {
        busy = false;
        button.removeAttribute('aria-busy');
      });
    }

    function applyCode() {
      var code = input.value.trim();
      if (!code) {
        setMessage('Bitte gib einen Code ein.', true);
        input.focus();
        return;
      }
      run(function () {
        setMessage('');
        return getCart().then(function (cart) {
          var codes = appliedCodes(cart);
          var exists = codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
          if (exists) {
            setMessage('Der Code ' + code + ' ist bereits eingelöst.');
            return;
          }
          return updateCodes(codes.concat(code)).then(function (updated) {
            var entry = (updated.discount_codes || []).find(function (d) {
              return d.code.toLowerCase() === code.toLowerCase();
            });
            if (entry && entry.applicable) {
              input.value = '';
              setMessage('Der Code ' + entry.code + ' wurde angewendet.');
              renderCodes(updated);
              rebuildDrawer();
              return;
            }
            setMessage('Der Code ' + code + ' ist ungültig oder gilt nicht für deinen Warenkorb. Geschenkkarten löst du an der Kasse ein.', true);
            return updateCodes(appliedCodes(updated)).then(renderCodes);
          });
        });
      });
    }

    function removeCode(code) {
      run(function () {
        setMessage('');
        return getCart().then(function (cart) {
          var codes = appliedCodes(cart).filter(function (c) { return c !== code; });
          return updateCodes(codes).then(function (updated) {
            renderCodes(updated);
            rebuildDrawer();
          });
        });
      });
    }

    button.addEventListener('click', applyCode);
    input.addEventListener('keydown', function (evt) {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        applyCode();
      }
    });
    input.addEventListener('input', function () { setMessage(''); });

    function refresh() {
      getCart().then(renderCodes).catch(function () {});
    }

    var products = document.querySelector('#CartDrawer [data-products]');
    if (products && window.MutationObserver) {
      new MutationObserver(refresh).observe(products, { childList: true });
    }
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
